import * as Headless from '@headlessui/react'
import clsx from 'clsx'
import React, { forwardRef } from 'react'
import { Link } from './link'

const solidColors = {
  'dark/zinc': 'border-zinc-900 bg-zinc-900 text-white shadow-sm hover:bg-zinc-800 active:bg-zinc-950',
  dark: 'border-zinc-900 bg-zinc-900 text-white shadow-sm hover:bg-zinc-800 active:bg-zinc-950',
  zinc: 'border-zinc-600 bg-zinc-600 text-white shadow-sm hover:bg-zinc-700 active:bg-zinc-800',
  white: 'border-zinc-200 bg-white text-zinc-950 shadow-sm hover:bg-zinc-50 active:bg-zinc-100',
  light: 'border-zinc-200 bg-white text-zinc-950 shadow-sm hover:bg-zinc-50 active:bg-zinc-100',
  blue: 'border-blue-600 bg-blue-600 text-white shadow-sm hover:bg-blue-500 active:bg-blue-700',
  indigo: 'border-indigo-600 bg-indigo-600 text-white shadow-sm hover:bg-indigo-500 active:bg-indigo-700',
  cyan: 'border-cyan-300 bg-cyan-300 text-cyan-950 shadow-sm hover:bg-cyan-200 active:bg-cyan-400',
  emerald: 'border-emerald-600 bg-emerald-600 text-white shadow-sm hover:bg-emerald-500 active:bg-emerald-700',
  green: 'border-green-600 bg-green-600 text-white shadow-sm hover:bg-green-500 active:bg-green-700',
  amber: 'border-amber-400 bg-amber-400 text-amber-950 shadow-sm hover:bg-amber-300 active:bg-amber-500',
  orange: 'border-orange-500 bg-orange-500 text-white shadow-sm hover:bg-orange-400 active:bg-orange-600',
  red: 'border-red-600 bg-red-600 text-white shadow-sm hover:bg-red-500 active:bg-red-700',
  rose: 'border-rose-500 bg-rose-500 text-white shadow-sm hover:bg-rose-400 active:bg-rose-600',
  pink: 'border-pink-500 bg-pink-500 text-white shadow-sm hover:bg-pink-400 active:bg-pink-600',
  purple: 'border-purple-500 bg-purple-500 text-white shadow-sm hover:bg-purple-400 active:bg-purple-600',
  violet: 'border-violet-500 bg-violet-500 text-white shadow-sm hover:bg-violet-400 active:bg-violet-600',
  sky: 'border-sky-500 bg-sky-500 text-white shadow-sm hover:bg-sky-400 active:bg-sky-600',
  teal: 'border-teal-600 bg-teal-600 text-white shadow-sm hover:bg-teal-500 active:bg-teal-700',
  lime: 'border-lime-400 bg-lime-400 text-lime-950 shadow-sm hover:bg-lime-300 active:bg-lime-500',
  yellow: 'border-yellow-300 bg-yellow-300 text-yellow-950 shadow-sm hover:bg-yellow-200 active:bg-yellow-400',
  fuchsia: 'border-fuchsia-500 bg-fuchsia-500 text-white shadow-sm hover:bg-fuchsia-400 active:bg-fuchsia-600',
}

export const Button = forwardRef(function Button({ color = 'dark/zinc', outline, plain, className, children, ...props }, ref) {
  const classes = clsx(
    'relative isolate inline-flex items-center justify-center gap-2 rounded-lg border px-3.5 py-2 text-sm font-semibold transition',
    'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
    '[&>svg]:h-4 [&>svg]:w-4 [&>svg]:shrink-0',
    outline
      ? 'border-zinc-300 bg-white text-zinc-950 shadow-sm hover:bg-zinc-50 active:bg-zinc-100'
      : plain
        ? 'border-transparent bg-transparent text-zinc-700 shadow-none hover:bg-zinc-100 active:bg-zinc-200'
        : solidColors[color] || solidColors['dark/zinc'],
    className
  )

  if (typeof props.href === 'string') {
    return (
      <Link {...props} className={classes} ref={ref}>
        <TouchTarget>{children}</TouchTarget>
      </Link>
    )
  }

  return (
    <Headless.Button {...props} className={classes} ref={ref}>
      <TouchTarget>{children}</TouchTarget>
    </Headless.Button>
  )
})

export function TouchTarget({ children }) {
  return (
    <>
      <span
        className="absolute left-1/2 top-1/2 hidden h-11 w-11 -translate-x-1/2 -translate-y-1/2 pointer-coarse:block"
        aria-hidden="true"
      />
      {children}
    </>
  )
}
